import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Factory, Warning } from "@phosphor-icons/react";

export default function Departments() {
  const [depts, setDepts] = useState([]);
  useEffect(() => { api.get("/departments").then((r) => setDepts(r.data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-5xl px-6 py-8 fade-up" data-testid="departments-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">Highberg</p>
      <h1 className="font-head text-3xl font-extrabold tracking-tighter">Departamente Highberg</h1>
      <p className="mt-1 text-sm text-muted-foreground">Alege un departament pentru coada de lucru, documente și scurtături.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {depts.map((d) => (
          <Link key={d.key} to={`/departamente/${d.key}`} data-testid={`dept-card-${d.key}`}
            className="rounded-xl border border-border bg-white/[0.02] p-5 transition-colors hover:border-primary/50 hover:bg-white/[0.04]">
            <div className="flex items-center gap-2 text-primary"><Factory size={20} weight="bold" /><span className="font-semibold text-foreground">{d.label}</span></div>
            <p className="mt-2 text-xs text-muted-foreground">{d.description}</p>
            <div className="mt-3 flex flex-wrap gap-2 text-xs">
              <span className="rounded-full bg-sky-500/15 px-2 py-0.5 text-sky-300">{d.active} în lucru</span>
              {d.overdue > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-red-500/15 px-2 py-0.5 text-red-300"><Warning size={12} /> {d.overdue} întârziate</span>}
            </div>
          </Link>
        ))}
        {depts.length === 0 && <p className="text-sm text-muted-foreground">Nu ai acces la niciun departament.</p>}
      </div>
    </div>
  );
}
